/**
 * Pill Search - Version: 30.0 - READONLY HACK + SCROLL POLICE
 */

(function() {
  'use strict';

  if (window.PillSearchInitialized) return;
  window.PillSearchInitialized = true;

  const CONFIG = {
    debounceDelay: 300,
    minQueryLength: 2,
    resultsLimit: 6,
    sectionId: 'predictive-search',
    portalGap: 12
  };

  let debounceTimer = null;
  let currentController = null;
  let activePortal = null;
  let portalPositioned = false;
  
  // --- POLÍCIA DE SCROLL ---
  // Variáveis para travar o scroll na força bruta se necessário
  let lockedScrollY = 0;
  let isScrollLocked = false;

  const scrollPolice = () => {
    if (isScrollLocked && window.scrollY !== lockedScrollY) {
      // 'instant' e obrigatorio: sem ele o scrollTo herda o
      // scroll-behavior: smooth do <html> e a propria correcao vira
      // uma animacao visivel - exatamente o efeito que queremos evitar.
      window.scrollTo({ top: lockedScrollY, left: 0, behavior: 'instant' });
    }
  };

  function engageScrollLock() {
    lockedScrollY = window.scrollY;
    isScrollLocked = true;
    window.addEventListener('scroll', scrollPolice, { passive: false });
    
    // Solta a trava após 200ms (tempo suficiente para o navegador desistir de pular)
    setTimeout(() => {
      isScrollLocked = false;
      window.removeEventListener('scroll', scrollPolice);
    }, 200);
  }
  // -------------------------

  function init() {
    const wrappers = document.querySelectorAll('[data-search-wrapper]');
    wrappers.forEach(initWrapper);
    initGlobalListeners();
  }

  function initWrapper(wrapper) {
    const searchId = wrapper.dataset.searchId;
    let portal = document.querySelector(`.search-results-portal[data-for="${searchId}"]`);
    
    if (!portal) {
       const template = document.querySelector(`[data-search-portal-template="${searchId}"]`);
       if (template) {
          portal = template.content.cloneNode(true).querySelector('.search-results-portal');
          portal.dataset.for = searchId;
          document.body.appendChild(portal);
          if (wrapper.classList.contains('mobile-search')) portal.classList.add('is-mobile');
          else portal.classList.add('is-desktop');
       }
    }
    
    const elements = {
      input: wrapper.querySelector('[data-search-input]'),
      btn: wrapper.querySelector('[data-pill-toggle]'),
      form: wrapper.querySelector('form'),
      portal: portal,
      results: portal ? portal.querySelector('[data-search-results]') : null
    };

    if (!elements.input || !elements.btn || !elements.portal) return;

    wrapper._pillSearch = elements;
    const searchUrl = wrapper.dataset.searchUrl || '/search/suggest';

    // Eventos do Botão
    elements.btn.addEventListener('mousedown', engageScrollLock);
    elements.btn.addEventListener('touchstart', engageScrollLock, { passive: true });

    elements.btn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();

      if (wrapper.classList.contains('active')) {
        if (elements.input.value.trim()) {
          elements.form.submit();
        } else {
          closeSearch(wrapper, elements);
        }
      } else {
        openSearch(wrapper, elements);
      }
    });

    elements.input.addEventListener('input', function() {
      const query = this.value.trim();
      clearTimeout(debounceTimer);

      if (query.length < CONFIG.minQueryLength) {
        closePortal(elements);
        wrapper.classList.remove('is-loading');
        return;
      }

      debounceTimer = setTimeout(() => {
        fetchResults(wrapper, elements, query, searchUrl);
      }, CONFIG.debounceDelay);
    });

    // Ao focar, ativamos a polícia de scroll novamente por segurança
    elements.input.addEventListener('focus', function(e) {
      if (!isScrollLocked) engageScrollLock();

      if (elements.results && elements.results.innerHTML.trim().length > 0) {
         openPortal(wrapper, elements);
      }
    });
  }

  function openSearch(wrapper, elements) {
    // 1. Ativa a polícia de Scroll (Trava a posição atual)
    engageScrollLock();

    document.querySelectorAll('[data-search-wrapper].active').forEach(w => {
      if (w !== wrapper && w._pillSearch) {
        w.classList.remove('active');
        closePortal(w._pillSearch);
      }
    });

    wrapper.classList.add('active');
    
    // 2. O HACK DO READONLY
    // Navegadores não rolam a tela para inputs "readonly".
    // Definimos como readonly, focamos, e removemos logo depois.
    elements.input.setAttribute('readonly', 'true');

    setTimeout(() => {
      // Foca no elemento "travado"
      elements.input.focus({ preventScroll: true });
      
      // Remove a trava de digitação logo em seguida
      setTimeout(() => {
        elements.input.removeAttribute('readonly');
      }, 50);
      
    }, 10);
  }

  function closeSearch(wrapper, elements) {
    wrapper.classList.remove('active', 'is-loading');
    closePortal(elements);
  }

  function closeAllSearches() {
    document.querySelectorAll('[data-search-wrapper].active').forEach(wrapper => {
      if (wrapper._pillSearch) closeSearch(wrapper, wrapper._pillSearch);
    });
  }

  function initGlobalListeners() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('[data-search-wrapper]') && !e.target.closest('.search-results-portal')) {
        closeAllSearches();
      }
    });
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAllSearches();
    });

    window.addEventListener('resize', () => {
      if (activePortal) positionPortal(activePortal.wrapper, activePortal.elements);
    }, { passive: true });
  }

  function openPortal(wrapper, elements) {
    positionPortal(wrapper, elements);
    elements.portal.classList.add('is-open');
    activePortal = { wrapper, elements };
  }

  function closePortal(elements) {
    if (elements && elements.portal) elements.portal.classList.remove('is-open');
    activePortal = null;
  }

  function positionPortal(wrapper, elements) {
    const form = wrapper.querySelector('.search-pill-form') || wrapper;
    const portal = elements.portal;
    const rect = form.getBoundingClientRect();
    const isMobile = wrapper.classList.contains('mobile-search');
    
    portal.style.position = 'fixed';
    portal.style.top = `${rect.bottom + CONFIG.portalGap}px`;
    
    if (isMobile) {
      portal.style.width = `${Math.min(rect.width, window.innerWidth - 20)}px`;
      portal.style.left = `${rect.left}px`;
    } else {
      portal.style.width = '380px';
      portal.style.right = `${window.innerWidth - rect.right}px`;
      portal.style.left = 'auto';
    }
  }

  function fetchResults(wrapper, elements, query, searchUrl) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    wrapper.classList.add('is-loading');
    
    const params = new URLSearchParams({
      q: query,
      'section_id': CONFIG.sectionId,
      'resources[type]': 'product',
      'resources[limit]': CONFIG.resultsLimit
    });
    const url = `${searchUrl}${searchUrl.includes('?') ? '&' : '?'}${params.toString()}`;

    fetch(url, { signal: currentController.signal })
      .then(res => res.text())
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const content = doc.querySelector('#predictive-search-results') || 
                        doc.querySelector('#shopify-section-predictive-search');
                        
        if (content && content.innerHTML.trim()) {
           elements.results.innerHTML = content.innerHTML;
        } else {
           elements.results.innerHTML = '<div class="simple-search-empty">Nenhum produto encontrado</div>';
        }
        openPortal(wrapper, elements);
      })
      .catch(e => { if (e.name !== 'AbortError') console.error(e); })
      .finally(() => wrapper.classList.remove('is-loading'));
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

})();